import React from 'react';
import { formatDate } from '@mysimpledb/shared/utils/formatDate';
import './ListDataWeb.css';
import './AttachmentSearchResultsWeb.css';

function formatMatchSource(source) {
  switch (source) {
    case 'filename':
      return 'Matched filename';

    case 'entry_title':
      return 'Matched entry title';

    case 'content':
      return 'Matched content';

    default:
      return '';
  }
}

export default function AttachmentSearchResultsWeb({
  results,
  totalAttachmentsFound,
  onEntryClick,
  onAttachmentClick,
}) {
  return (
    <div className="list-outer-wrapper">
      <form className="userdata-form">
        <div className="tab-content">
          <div className="list-header attachment-search-header">
            <span className="list-col attachment-entry-title">Entry</span>
            <span className="list-col attachment-file-name">File</span>
            <span className="list-col attachment-created">Created</span>
            <span className="list-col attachment-updated">Updated</span>
            <span className="list-col attachment-sync">Sync</span>
          </div>

          {results.length === 0 ? (
            <div className="attachment-search-empty">
              No attachments matched your search.
            </div>
          ) : (
            results.map((item) => (
              <div
                key={item.attachmentId}
                className="list-item attachment-search-row"
              >
                <span
                  className="list-col attachment-entry-title item attachment-link"
                  onClick={() => onEntryClick(item)}
                >
                  {item.entryTitle}
                </span>

                <div className="list-col attachment-file-name item">
                  <span
                    className="attachment-link"
                    onClick={() => onAttachmentClick(item)}
                  >
                    <strong>{item.fileName}</strong>
                  </span>
                  {!item.extractedTextSnippet && item.matchSource && (
                    <div className="attachment-match-source">
                      {formatMatchSource(item.matchSource)}
                    </div>
                  )}

                  {item.extractedTextSnippet && (
                    <div
                      className="attachment-match-snippet"
                      dangerouslySetInnerHTML={{
                        __html: item.extractedTextSnippet,
                      }}
                    />
                  )}
                </div>

                {item.detectedObjects?.length > 0 && (
                  <div className="attachment-detected-tags">
                    {item.detectedObjects.slice(0, 6).map((tag) => (
                      <span key={tag} className="attachment-detected-tag">
                        {tag}
                      </span>
                    ))}
                  </div>
                )}

                <span className="list-col attachment-created item">
                  {formatDate(item.createdAt)}
                </span>

                <span className="list-col attachment-updated item">
                  {formatDate(item.updatedAt)}
                </span>

                <span
                  className={`list-col attachment-sync item sync-${item.syncStatus}`}
                >
                  {formatSyncStatus(item.syncStatus)}
                </span>
              </div>
            ))
          )}
        </div>
      </form>

      <span className="entry-counter">
        {totalAttachmentsFound > 0
          ? `${totalAttachmentsFound} found`
          : '0 found'}
      </span>
    </div>
  );
}

function formatSyncStatus(status) {
  switch (status) {
    case 'synced':
      return 'Synced';
    case 'synced-unavailable':
      return 'Synced unavailable';
    case 'not-synced':
      return 'Not synced';
    default:
      return '';
  }
}
